var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import classNames from "classnames";
import IconContainer from "../IconContainer";
const YahooIcon = (_a) => {
    var { className, size, title } = _a, props = __rest(_a, ["className", "size", "title"]);
    return (React.createElement(IconContainer, Object.assign({ className: classNames("gerudo-icon-yahoo", size, className) }, props),
        React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24", role: "img", "aria-label": title },
            React.createElement("path", { fill: "currentColor", stroke: "none", role: "presentation", d: "M12,0A12,12,0,1,0,24,12,12,12,0,0,0,12,0Zm2.3,15.556v.555h-6v-.555h1.889V12.988L6.623,8.556H4.741V7.778h6.333v.778H9.312l2.537,3.33,2.387-2.108H12.852V9.111h5.341l-.513.667H15.926L12.3,12.761v2.8Zm3.674.693-.907-.014.017-1.087.907.014ZM18,14.437l-.906-.014.056-3.625,1.888.03Z" }))));
};
YahooIcon.defaultProps = {
    title: "Yahoo icon",
};
export default YahooIcon;
export { YahooIcon };
//# sourceMappingURL=Yahoo.js.map